import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/node/app/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const ListBadges = makeShortcode("ListBadges");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ImageCard = makeShortcode("ImageCard");
const ArticleCard = makeShortcode("ArticleCard");
const ImageGallery = makeShortcode("ImageGallery");
const ImageGalleryImage = makeShortcode("ImageGalleryImage");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`If you can explain technical processes, you can explain anything. I can.`}</p>
    </PageDescription>
    <ListBadges frontmatter={props.pageContext.frontmatter} mdxType="ListBadges" />
    <h2>{`ThoughtCo. (Formerly About.com)`}</h2>
    <Row mdxType="Row">
  <Column colMd={4} colLg={4} mdxType="Column">
        <ImageCard hoverColor="light" titleColor="light" subTitleColor="light" iconColor="light" actionIcon="launch" aspectRatio="2:1" href="https://www.thoughtco.com/bill-powell-5185090" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "548px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAABaklEQVQoz6WSS2vCQBSF83Mk0bnzyljTJCXTpo80CwXTB9SFS3GXCkJrkYI7cSFuLJJ24SZCNrrRn1fMVFta2k0/Lncx3HsYzrka+wcaY4xzbuZwzn9OqEfVv41onHMAKBQKhmEwxoQQeyHVAYBzTrZQowiUUHMnoAFAGIbdbrfZbAohdF0v5QCArusY4zAMEUKVimVVxN21b1vlEiLqA9vlIAjm8/lkMkmSpNVqDQaDdrvdaDR6vd5wOMyybDQaJa9vD/FNVPPqVXl2YgMQzplGKS2Xy/1+P47j8Xi8Xq/TNM2ybLVaLRaLzWYzm81eptM0XTze30ZV7ymOnrtXx56FCdVyG0wppeu6tm37vl+r1aSU9Xq90+ksl0vf9w8tKwgupXcUVeXFqXPuO659QGm+zBgDAIwxIQQhZBiGstDzPMdxEEKEkNwFXCxhhAhCBBP6EZVKQrG3Wgih5L46b+7qM+ffUHJ/HMk70A6dyk9n6y4AAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "thoughtco logo dark3",
              "title": "thoughtco logo dark3",
              "src": "/static/c9576274df0d8c581bfd953f8c2739c4/8bd1a/thoughtco-logo-dark3.png",
              "srcSet": ["/static/c9576274df0d8c581bfd953f8c2739c4/7fc1e/thoughtco-logo-dark3.png 288w", "/static/c9576274df0d8c581bfd953f8c2739c4/8bd1a/thoughtco-logo-dark3.png 548w"],
              "sizes": "(max-width: 548px) 100vw, 548px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ImageCard>
      </Column>
      <Column colMd={8} colLg={8} mdxType="Column">
        <p>{`For years, I wrote regular paid articles for the “Content Management Systems” channel at About.com. The company was later bought and most of my articles have vanished, but you can still find a few on the current iteration of the site, `}<a parentName="p" {...{
            "href": "https://www.thoughtco.com/bill-powell-5185090"
          }}>{`ThoughtCo.`}</a></p>
      </Column>
    </Row>
    <Row mdxType="Row">
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" title="All About CMS Plug-Ins" href="https://www.thoughtco.com/what-is-a-cms-plugin-756561" actionIcon="launch" mdxType="ArticleCard">
          <img {...{
            "src": "https://www.thoughtco.com/thmb/ISSQtN-cZ8yxiYXYT-2J3t_DrtY=/768x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/person-apple-laptop-notebook-57f0887d5f9b586c3551c22b.jpg",
            "alt": "Cover image"
          }}></img>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" title="What Is a Drupal Content Type?" href="https://www.thoughtco.com/drupal-content-type-756684" actionIcon="launch" mdxType="ArticleCard">
          <img {...{
            "src": "https://www.thoughtco.com/thmb/wrZQ7ibFsEZcvLmAmH-qTnfWy_o=/768x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/druplicon_blue_BG_A-56a16bc45f9b58b7d0bf3049.jpg",
            "alt": "Cover image"
          }}></img>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard color="dark" title="All You Need to Know About Wordpress.com 'Premium Upgrades'" href="https://www.thoughtco.com/what-is-wordpress-premium-upgrade-756529" actionIcon="launch" mdxType="ArticleCard">
          <img {...{
            "src": "https://www.thoughtco.com/thmb/50anPbcF3eEIFJe_stB7ztQMwB0=/768x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/wp-logo-c6d5508d66b4400c9d1c64497d516ece.jpg",
            "alt": "Cover image"
          }}></img>
        </ArticleCard>
  </Column>
    </Row>
    <h2>{`Drupal, Aegir, and Omega8.cc`}</h2>
    <Row mdxType="Row">
  <Column colMd={6} colLg={6} mdxType="Column">
        <p>{`When I was building sites with `}<a parentName="p" {...{
            "href": "/web-dev/#past-cms-software-i-no-longer-use"
          }}>{`Drupal`}</a>{`, I relied heavily on `}<a parentName="p" {...{
            "href": "https://www.aegirproject.org/"
          }}>{`Aegir`}</a>{`, a specialized system for hosting Drupal sites. My enthusiastic articles on About.com attracted the attention of `}<a parentName="p" {...{
            "href": "https://omega8.cc/"
          }}>{`Omega8.cc`}</a>{`, an Aegir hosting company, which led to a lovely project working with them on their technical documentation.`}</p>
  </Column>
  <Column colMd={6} colLg={6} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "50%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7DAAAOwwHHb6hkAAABs0lEQVQoz4XRu2sUURTH8e+dzc7uKuui7s1mLQwhhRuda0wp4gOUFJJKDdhYLFoo8QFa+ihNJYIP0D0jKYIRLAUrOwuNWEVs1DlT2KQwhf+AXNnZNdnsBjzwYw4zhw+HM/CvRHuSdqP/T5zCws9Ov6nWoWzwIqJHEB1B9BSidUTLiJYQrXSfDURHM9D7PrB6AFqJ6WDJOK1EaP24Q5xOI/oU0duINhGNEZ3v5gmi1QyM0z7QOnjn4fVvePylyOLqGV6tHePRSoU4nUB0G8+/70Z0BtH9SDJmWkmDr57CsidYWoNV3wMOH9zo5xayndtvmb4Gbz08+AQPP8ObP7Di4YOn9uxbNl7cWWfPrSWIjvdtWJs0jEy18Rlqh+5Rm1zMvr38ZTh5yfSeO+jpDYZ8WOr7IW2wkzLWLWPdR6x7gY3q7BiFICwCd4HrwNU83HifK9+fMLlzwAkGajPYxLpZrDuLjcbYtQ8KlRxwGjgPNAO4Mh+ULlQxbfDoVqDpguNYN4d1N7HRZWwUUpsaGA8BPzTMYTPE1rWxYQ7r8ljXwLrtnduug6Z7SFMA4/N7zWwQDlh/AXvomu7EZw3WAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Drupal, Aegir, and Omega8.cc",
            "title": "Drupal, Aegir, and Omega8.cc",
            "src": "/static/a80a361b4798a7e4a578709994ee5e5d/3cbba/drupal-aegir-omega8cc-logo.png",
            "srcSet": ["/static/a80a361b4798a7e4a578709994ee5e5d/7fc1e/drupal-aegir-omega8cc-logo.png 288w", "/static/a80a361b4798a7e4a578709994ee5e5d/a5df1/drupal-aegir-omega8cc-logo.png 576w", "/static/a80a361b4798a7e4a578709994ee5e5d/3cbba/drupal-aegir-omega8cc-logo.png 1152w", "/static/a80a361b4798a7e4a578709994ee5e5d/7dc98/drupal-aegir-omega8cc-logo.png 1200w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
  </Column>
    </Row>
    <h2>{`Transform Your Nonprofit Website`}</h2>
    <Row mdxType="Row">
      <Column colMd={4} colLg={4} noGutterSm noGutterMd noGutterLg noGutterXl mdxType="Column">
        <ImageGallery mdxType="ImageGallery">
          <ImageGalleryImage alt="Transform Your Nonprofit's Website" title="Transform Your Nonprofit's Website" mdxType="ImageGalleryImage">
            <span {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "153.81944444444443%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAfABQDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAIBAwQF/8QAFwEBAQEBAAAAAAAAAAAAAAAAAgUBA//aAAwDAQACEAMQAAAB2IuiV1csBrUThonsgMf/xAAcEAABBAMBAAAAAAAAAAAAAAACAAEDERASITH/2gAIAQEAAQUCeSi3ckPhhZxhTUj4EG2J+jFsJL//xAAXEQEAAwAAAAAAAAAAAAAAAAAQARES/9oACAEDAQE/ASNUf//EABoRAAICAwAAAAAAAAAAAAAAAAARAQIQEmH/2gAIAQIBAT8BUI0kVH3H/8QAHxABAAEEAQUAAAAAAAAAAAAAARAAAhEhAxJRYcHh/9oACAEBAAY/Ase60b8MfJUMtPUYjAo9yhu5Lro//8QAHxAAAgIBBAMAAAAAAAAAAAAAAREAITEQQVFhgZGh/9oACAEBAAE/IXQB+AgrFTIDGVt9lxyX8TMC+VE79TGUFAbw958N6OF1VAlSDjAguf/aAAwDAQACAAMAAAAQZNMy/8QAGBEAAwEBAAAAAAAAAAAAAAAAAAERIRD/2gAIAQMBAT8Q2lQlJqfP/8QAGBEBAQEBAQAAAAAAAAAAAAAAAREAIRD/2gAIAQIBAT8QiIVy3eZOpPH/xAAeEAEBAAICAwEBAAAAAAAAAAABEQAhMUFRYXGBsf/aAAgBAQABPxBS2Zdw1djnTquxdM/uMylbSw9XJ6UZKnH3GSMOmRn5hRo31jYJBVK6MVVqLyHvedv3CmNSOE8nZ6xWzAIJdb84oWcuf//Z')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "transform your nonprofit website",
                "title": "transform your nonprofit website",
                "src": "/static/15aab26b455eb07ff40331f16496d56c/2e753/transform-your-nonprofit-website.jpg",
                "srcSet": ["/static/15aab26b455eb07ff40331f16496d56c/69549/transform-your-nonprofit-website.jpg 288w", "/static/15aab26b455eb07ff40331f16496d56c/473e3/transform-your-nonprofit-website.jpg 576w", "/static/15aab26b455eb07ff40331f16496d56c/2e753/transform-your-nonprofit-website.jpg 1152w", "/static/15aab26b455eb07ff40331f16496d56c/0d3c0/transform-your-nonprofit-website.jpg 1560w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy",
                "decoding": "async"
              }}></img>{`
    `}</span>
          </ImageGalleryImage>
        </ImageGallery>
      </Column>
      <Column colMd={8} colLg={8} mdxType="Column">
        <p><em parentName="p">{`(Forthcoming.)`}</em></p>
        <p>{`Need a new website? This book could save you thousands of dollars… and months of heartbreak.`}</p>
        <p>{`With over 15 years of experience serving nonprofits and small businesses, Bill Alive is that rare professional who’s willing to talk you `}<em parentName="p">{`out`}</em>{` of hiring him if he knows you can do it yourself.`}</p>
        <p>{`But this isn’t another “How to Install WordPress” listicle that will leave you confused at Step 13 (and your site hacked in six months).`}</p>
        <p>{`Instead, you’ll learn the critical, `}<em parentName="p">{`non-technical`}</em>{` meta questions that you need to answer before you even begin thinking about software. Questions too many tech-focused web developers may never think to ask you… until you’ve already blown through your budget on a site that feels all wrong.`}</p>
        <p>{`Hire someone? Do it yourself? The answer is… it depends. And this book will help you work through to the answer that is right for you.`}</p>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      